import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography } from '@mui/material'
import {
  AutocompleteStyle,
  FormError,
  InputBaseStyle,
  TextFieldModalStyle,
  TextFieldStyle
} from '../../Deal.style'
import PaperAutoComplete from '../../../../components/PaperAutoComplete/PaperAutoComplete'
import NumericFormatModal from '../../../../components/ModalApp/components/NumericFormatModal/NumericFormatModal'
import {
  CheckboxStyle,
  FormControlLabelStyle,
  Label
} from '../../../../components/styled/global.style'
import { ButtonGroupStyle, OptionContainer, OptionCounterparty, SideButton } from '../../Deal.style'
import CheckBoxIcon from '@mui/icons-material/CheckBox'
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank'

const SwapDealMarketMakerSide = ({
  form,
  sides,
  handelFormChange,
  handelFocusCurrencyPair,
  handelBlurCurrencyPair,
  errors,
  handelDateChange,
  swapOption,
  checkPrimeBrokerIsRBS,
  fixingSource,
  marketMakers
}) => {
  return (
    <>
      <Box width={'100%'}>
        <Label>Trade Type *</Label>
        <InputBaseStyle value={`Market ${form.deal_type.name}`} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Counterparty *</Label>
        {Array.isArray(marketMakers.data) && (
          <AutocompleteStyle
            onChange={(event, element) => {
              event.target.name = 'market_maker'
              element = element ?? ''
              handelFormChange(event, element)
            }}
            size={'small'}
            value={form.market_maker}
            options={marketMakers.data.map(({ name }) => name)}
            onBlur={handelBlurCurrencyPair}
            renderOption={(props, option) => {
              return (
                <OptionContainer {...props} key={option}>
                  <Typography>{option.split(' ').slice(0, -1).join(' ')} </Typography>
                  <OptionCounterparty>{option.split(' ').at(-1)} </OptionCounterparty>
                </OptionContainer>
              )
            }}
            renderInput={params => (
              <TextFieldModalStyle fullWidth {...params} placeholder={'Select CP'} />
            )}
            ListboxComponent={PaperAutoComplete}
          />
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Trade Date *</Label>
        <TextFieldStyle type="datetime-local" value={form.trade_date} disabled />
      </Box>
      <Box width={'100%'}>
        <Label>Currency Pair *</Label>
        <InputBaseStyle
          value={form.currency_pair}
          name="currency_pair"
          onChange={handelFormChange}
          onFocus={handelFocusCurrencyPair}
          onBlur={handelBlurCurrencyPair}
          error={errors.currency_pair}
          disabled
        />
        {errors.currency_pair !== '' && <FormError>{errors.currency_pair}</FormError>}
      </Box>
      <Box width={'100%'}>
        <Label>Client Side *</Label>
        {Array.isArray(sides.data) && (
          <ButtonGroupStyle variant="outlined">
            {sides.data.map(({ name }, id) => (
              <SideButton
                name="client_side"
                key={id}
                disabled={form.client_side !== name}
                value={name}
                select={String(form.client_side === name)}
              >
                {name}
              </SideButton>
            ))}
          </ButtonGroupStyle>
        )}
      </Box>
      <Box width={'100%'}>
        <Label>Quantity *</Label>
        <NumericFormatModal
          value={form.quantity}
          name="quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
          disabled={true}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Leg Quantity *</Label>
        <NumericFormatModal
          value={form.far_leg_quantity}
          name="far_leg_quantity"
          handelFormChange={handelFormChange}
          placeholder="0.00"
          disabled={true}
        />
      </Box>
      <Box width={'100%'}>
        <Label>Price *</Label>
        <InputBaseStyle
          value={form.market_maker_price}
          name="market_maker_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Price *</Label>
        <InputBaseStyle
          value={form.market_maker_far_price}
          name="market_maker_far_price"
          onChange={handelFormChange}
          placeholder="0.0000"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Market Value Date *</Label>
        <TextFieldStyle
          type="date"
          disabled
          value={form.client_value_date}
          placeholder="dd-mm-yyyy"
        />
      </Box>
      <Box width={'100%'}>
        <Label>Far Value Date *</Label>
        <TextFieldStyle
          disabled
          type="date"
          value={form.client_far_value_date}
          placeholder="dd-mm-yyyy"
        />
      </Box>
      {swapOption && (
        <>
          <Box width={'100%'}>
            <Label>Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              variant="outlined"
              value={form.fixing_date}
              onChange={event => handelDateChange('fixing_date', event.target.value)}
            />
          </Box>
          <Box width={'100%'}>
            <Label>Far Fixing Date *</Label>
            <TextFieldStyle
              type="date"
              name="far_fixing_date"
              value={form.far_fixing_date}
              placeholder="dd-mm-yyyy"
              onChange={event => handelDateChange('far_fixing_date', event.target.value)}
            />
          </Box>
          <Box width={'100%'}>
            <Label>Fixing Source *</Label>
            {Array.isArray(fixingSource.data) && (
              <AutocompleteStyle
                onChange={(event, element) => {
                  event.target.name = 'fixing_source'
                  element = element ?? ''
                  handelFormChange(event, element)
                }}
                size={'small'}
                value={form.fixing_source}
                options={fixingSource.data.map(({ name }) => name)}
                renderInput={params => (
                  <TextFieldModalStyle fullWidth {...params} placeholder="Select Fix Source" />
                )}
                ListboxComponent={PaperAutoComplete}
              />
            )}
          </Box>
        </>
      )}
      <Box width={'100%'}>
        <Label>Market Note</Label>
        <InputBaseStyle
          value={form.market_maker_note}
          name="market_maker_note"
          onChange={handelFormChange}
        />
      </Box>
      {checkPrimeBrokerIsRBS && (
        <>
          <Box width={'100%'}>
            <Label>Bdr</Label>
            <InputBaseStyle value={form.bdr} name="bdr" onChange={handelFormChange} />
          </Box>
          <Box
            style={{
              display: 'flex',
              margin: 'inherit'
            }}
          >
            <FormControlLabelStyle
              onChange={handelFormChange}
              name="is_pba"
              style={{ color: 'white' }}
              control={
                <CheckboxStyle
                  style={{ marginRight: '8px' }}
                  checked={form.is_pba}
                  icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                  checkedIcon={<CheckBoxIcon fontSize="small" />}
                />
              }
              label="PBA"
            />
          </Box>
        </>
      )}
    </>
  )
}

export default SwapDealMarketMakerSide

SwapDealMarketMakerSide.propTypes = {
  form: PropTypes.object,
  sides: PropTypes.object,
  handelFormChange: PropTypes.func,
  handelFocusCurrencyPair: PropTypes.func,
  handelBlurCurrencyPair: PropTypes.func,
  errors: PropTypes.object,
  handelDateChange: PropTypes.func,
  swapOption: PropTypes.bool,
  fixingSource: PropTypes.object,
  marketMakers: PropTypes.object,
  checkPrimeBrokerIsRBS: PropTypes.bool
}
